import React from 'react'
import { COLORS } from '@borrowell/bw-styles'

import { useLocale } from '../context/LocaleContextProvider'

interface IProps {
  size: number
  color: string
}

export const ChevronDown: React.FC<IProps> = ({ size = 25, color = COLORS.NEUTRAL.COOL['600'] }) => {
  const label = useLocale().t('icon.chevronDown')
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label={label}>
      <title>{label}</title>
      <g
        id="Blog-Hero-Redesign-MVP---Categories"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g id="Mobile--Default" transform="translate(-302.000000, -438.000000)" stroke={color} strokeWidth="1.5">
          <g id="Group-9-Copy-4" transform="translate(20.000000, 383.000000)">
            <polyline id="Stroke-1" points="283 56.014 289.985 63 296.985 56" />
          </g>
        </g>
      </g>
    </svg>
  )
}

export const ChevronUp: React.FC<IProps> = ({ size = 25, color = COLORS.NEUTRAL.COOL['600'] }) => {
  const label = useLocale().t('icon.chevronUp')
  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label={label}>
      <title>{label}</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
        <g id="Mobile-Categories-Open" transform="translate(-302.000000, -438.000000)" stroke={color} strokeWidth="1.5">
          <g id="Group-9-Copy-5" transform="translate(20.000000, 383.000000)">
            <polyline
              id="Stroke-1"
              transform="translate(289.992500, 59.500000) rotate(-180.000000) translate(-289.992500, -59.500000) "
              points="283 56.014 289.985 63 296.985 56"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export const CaretDown: React.FC<IProps> = ({ size = 16, color = 'black' }) => {
  const label = useLocale().t('icon.caretDown')
  // Maintain original 17:16 aspect ratio from Figma
  const width = (size * 17) / 16
  const height = size

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={label}
    >
      <title>{label}</title>
      <path
        d="M8.51355 9.65549L12.8099 5.28146C13.0034 5.08446 13.32 5.08162 13.517 5.27514C13.714 5.46865 13.7169 5.78521 13.5234 5.98221L8.87138 10.7183C8.67585 10.9173 8.35523 10.9178 8.15907 10.7194L3.47771 5.98334C3.28359 5.78695 3.28543 5.47037 3.48182 5.27624C3.67821 5.08212 3.99479 5.08396 4.18891 5.28035L8.51355 9.65549Z"
        fill={color}
        stroke={color}
        strokeWidth="0.015625"
      />
    </svg>
  )
}

export const ChevronThick: React.FC<IProps> = ({ size = 24, color = COLORS.PRIMARY['900'] }) => {
  const label = useLocale().t('icon.chevronThick')
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={label}
    >
      <title>{label}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.58 11.0276C16.8489 11.2811 17 11.6249 17 11.9834C17 12.3419 16.8489 12.6857 16.58 12.9392L8.46603 20.5873C8.33372 20.7164 8.17545 20.8194 8.00045 20.8902C7.82546 20.9611 7.63725 20.9984 7.4468 20.9999C7.25635 21.0015 7.06747 20.9673 6.8912 20.8993C6.71493 20.8313 6.55478 20.731 6.42011 20.604C6.28543 20.4771 6.17893 20.3261 6.10681 20.16C6.03469 19.9938 5.9984 19.8158 6.00005 19.6363C6.00171 19.4568 6.04128 19.2794 6.11645 19.1144C6.19162 18.9495 6.30089 18.8003 6.43788 18.6756L13.5378 11.9834L6.43788 5.29118C6.17661 5.0362 6.03204 4.69469 6.0353 4.34021C6.03857 3.98573 6.18942 3.64664 6.45536 3.39598C6.72129 3.14532 7.08104 3.00313 7.45712 3.00005C7.8332 2.99697 8.19551 3.13324 8.46603 3.37951L16.58 11.0276Z"
        fill={color}
      />
    </svg>
  )
}
